// Axios 오류 → api_error 파라미터 정규화 (설계 §9.5). URL 원문·자유 텍스트는 절대 내보내지 않는다.
import type { ApiErrorParams } from './core'

const GROUPS: [string, RegExp][] = [
  ['seller', /seller-api/],
  ['admin', /admin-api(-stg)?\.brandi\.co\.kr/],
  ['order', /order-api/],
  ['adminapi', /adminapi\.brandi\.biz|localhost:9100/],
  ['valhalla', /valhalla-api/],
  ['mdm', /mdm\.selpi/],
]

// 등록 템플릿만 endpoint 로 내보낸다. 자유 텍스트가 경로에 들어가는 API(/seller/search/:text 등)는 등록하지 않는다 → unknown
export const ENDPOINT_TEMPLATES: [RegExp, string][] = [
  [/^\/seller\/menu\/\d+$/, '/seller/menu/:sellerNo'],
  [/^\/seller\/\d+$/, '/seller/:sellerNo'],
  [/^\/seller\/login$/, '/seller/login'],
  [/^\/auth\/callback$/, '/auth/callback'],
  [/^\/products$/, '/products'],
  [/^\/products\/\d+$/, '/products/:productNo'],
  [/^\/products\/\d+\/(details|sales|meta)$/, '/products/:productNo/$1'],
  [/^\/v2\/products\/sellerExcelDownload$/, '/v2/products/sellerExcelDownload'],
  [/^\/options\/bulk$/, '/options/bulk'],
  [/^\/order\/delivery\/invoice\/Info$/, '/order/delivery/invoice/Info'],
  [/^\/order\/delivery\/invoice$/, '/order/delivery/invoice'],
  [/^\/order\/status\/[a-z-]+$/, '/order/status/:action'],
  [/^\/order\/v1\/status\/[a-z-]+$/, '/order/v1/status/:action'],
  [/^\/claim$/, '/claim'],
  [/^\/claim\/v1\/status\/[a-z-]+$/, '/claim/v1/status/:action'],
  [/^\/claim\/naverpay\/[a-z-]+$/, '/claim/naverpay/:action'],
  [/^\/claims\/[a-z-]+$/, '/claims/:action'],
  [/^\/claims\/excel\/all$/, '/claims/excel/all'],
  [/^\/orders\/excel\/[a-z-]+$/, '/orders/excel/:type'],
  [/^\/v1\/seller-coupons(\/\d+)?$/, '/v1/seller-coupons'],
  [/^\/v1\/campaigns$/, '/v1/campaigns'],
  [/^\/v1\/campaigns\/md-proposals$/, '/v1/campaigns/md-proposals'],
  [/^\/v1\/campaigns\/\d+\/products$/, '/v1/campaigns/:campaignNo/products'],
  [/^\/v1\/campaigns\/\d+\/products\/excel$/, '/v1/campaigns/:campaignNo/products/excel'],
  [/^\/qna\/\d+\/answers$/, '/qna/:questionNo/answers'],
  [/^\/excel\/download\/list$/, '/excel/download/list'],
  [/^\/excel\/download\/\d+\/history$/, '/excel/download/:downloadNo/history'],
]

function pathOf(url: string, baseURL: string): string {
  try {
    const full = /^https?:/.test(url) ? url : `${baseURL || ''}${url}`
    return new URL(full, 'https://x.invalid').pathname
  } catch (e) {
    return ''
  }
}

export function templateOf(path: string): string {
  for (const [re, tpl] of ENDPOINT_TEMPLATES) if (re.test(path)) return path.replace(re, tpl)
  return 'unknown'
}

// 취소·인자 없는 reject 는 null (계측 대상 아님)
export function normalizeApiError(error: unknown): ApiErrorParams | null {
  try {
    if (!error || typeof error !== 'object') return null
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error as any
    if (e.__CANCEL__ || e.name === 'CanceledError' || e.code === 'ERR_CANCELED') return null
    const url: string = typeof e.config?.url === 'string' ? e.config.url : ''
    const base: string = typeof e.config?.baseURL === 'string' ? e.config.baseURL : ''
    const full = /^https?:/.test(url) ? url : base + url
    const group = GROUPS.find(([, re]) => re.test(full))
    const api_group = group ? group[0] : 'other'
    const endpoint = templateOf(pathOf(url, base))
    if (!e.response) return { endpoint, http_status: 0, error_code: 'network', api_group }
    const data = e.response.data || {}
    // admin-api 계열은 error.code, adminapi(FastAPI) 는 meta.code
    const code = data.error && data.error.code !== undefined ? data.error.code : data.meta ? data.meta.code : undefined
    return {
      endpoint,
      http_status: Number(e.response.status) || 0,
      error_code: code === undefined || code === null ? 'none' : String(code),
      api_group,
    }
  } catch (err) {
    return null
  }
}
